<template>
  <div>
    <UInput
      v-if="showCustomInput"
      v-model="model"
      class="w-full"
    />
    <USelect
      v-else
      v-model="model"
      :options="options"
      class="w-full"
    />
    <div class="mt-2 flex justify-end">
      <UButton
        variant="link"
        size="xs"
        class="ml-auto"
        :padded="false"
        @click="toggleCustomInput"
      >
        {{ showCustomInput ? 'Select from list' : 'Enter custom title' }}
      </UButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const model = defineModel<string>()
const showCustomInput = ref(false)

const options = ref([
  'Mr',
  'Mrs',
  'Ms',
  'Dr',
  'Prof',
  'Rev',
  'Sir',
  'Lady',
  'Lord',
  'Dame',
  'Mx',
])

function toggleCustomInput() {
  showCustomInput.value = !showCustomInput.value

  if (showCustomInput.value) {
    model.value = ''
  }
}
</script>